import React from "react";
import InstagramIcon from "@mui/icons-material/Instagram";

export const Footer = () => {
    const phoneNumber = "+381 60-3859-426";
    const [language, setLanguage] = React.useState("10"); // Default to "10" (Srpski)

    React.useEffect(() => {
        const storedLanguage = localStorage.getItem("selectedLanguage");
        if (storedLanguage) {
            setLanguage(storedLanguage);
        }

        const handleStorageChange = () => {
            setLanguage(localStorage.getItem("selectedLanguage") || "10");
        };

        window.addEventListener("storage", handleStorageChange);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);

    const HandleOpenMap = () => {
        const url = `https://maps.app.goo.gl/6wxPp2i9rRZ45HQs6`;
        window.open(url, "_blank");
    };

    return (
        <div>
            <a
                className='barbershop-zajednica-footer-title-adresa'
                onClick={HandleOpenMap}
                target='_blank'
                rel='noopener noreferrer'
            >
                <div>
                    <h2>Srpskog sovjeta 1a</h2>
                    <h2>11300, Smederevo</h2>
                    <h2>( {language == 20 ? "Click Me" : "Klikni me"} )</h2>
                </div>
            </a>

            <div className='barbershop-zajednica-footer-title-adresa'>
                <h2>{language == 20 ? "Visit our" : "Posetite"} Instagram</h2>
                <a
                    href='https://www.instagram.com/_zajednica_/'
                    target='_blank'
                    rel='noopener noreferrer'
                    style={{
                        marginTop: "10px",
                        width: "100%",
                        justifyContent: "center",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "8px",
                        color: "#f3f3f3",
                        textDecoration: "none",
                    }}
                >
                    <InstagramIcon
                        style={{ color: "#f3f3f3", fontSize: "40px" }}
                    />
                </a>
            </div>

            <div className='barbershop-zajednica-footer-title'>
                <h2>
                    {language == 20
                        ? "Or contact us by phone"
                        : "Ili nas kontaktirajte"}
                </h2>
            </div>
            <div className='barbershop-zajednica-footer-phone'>
                <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
            </div>
        </div>
    );
};
